import styled from '@emotion/styled';

const Item = styled('div')({ width: '100%' });

export default Item;
